import React, { memo } from 'react';
import { Stack, Typography } from 'investira.react.components';
import { validators } from 'investira.sdk';
import QuestaoCardTipo from '../_components/QuestaoCardTipo';
import { temValorResposta } from '../_shared/avaliacaoRespostaPayload';
const AvaliacoesGestorEditQuestoes = memo(props => {
  const {
    sessoes = {},
    sessoesQuestoes = {},
    activeCategoryId,
    respostas = {},
    onQuestionChange,
    mostrarApenasNaoRespondidas = false
  } = props;
  const xSessaoAtiva = sessoes[activeCategoryId];
  const xQuestoesCategoria = sessoesQuestoes[activeCategoryId];
  const xQuestoesExibidas = mostrarApenasNaoRespondidas
    ? (xQuestoesCategoria?.questoes || []).filter(
        pQuestao => !temValorResposta(respostas[pQuestao.id]?.resposta_id)
      )
    : xQuestoesCategoria?.questoes || [];
  if (validators.isEmpty(activeCategoryId) || validators.isEmpty(xSessaoAtiva)) {
    return null;
  }
  return (
    <Stack gap={2}>
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{
              textTransform: 'uppercase'
            }}>
            Sessão {`${xSessaoAtiva.sessao}`}
          </Typography>
        </Stack>
        <Typography variant="h5" color="textPrimary">
          {xSessaoAtiva.label}
        </Typography>
      </Stack>
      <Stack gap={3} pt={2}>
        {xQuestoesExibidas.map((xQuestao, xIndex) => {
          return (
            <QuestaoCardTipo
              key={xQuestao.id}
              index={xIndex}
              data={xQuestao}
              value={respostas[xQuestao.id]?.resposta_id ?? ''}
              resposta={respostas[xQuestao.id] || {}}
              onChange={onQuestionChange}
            />
          );
        })}
      </Stack>
    </Stack>
  );
});
export default AvaliacoesGestorEditQuestoes;
